import * as d3 from 'd3';
// import $ from 'jquery';

const consts = {
    barWidth: 35,
    otherLinesOpacity: 0.3,
    lineStroke: 1.5,
    lineStrokeHover: 2.5,
    pointOpacity: 0.4,
    pointOpacityLineHover: 0.9,
    pointRadiusLineHover: 0.5,
    pointRadius: 4,
    pointRadiusHover: 6
};

class Chart {
    protected chart: any;
    protected parent: any;
    protected chartHeight: number;
    protected data: any;
    protected xlabels: any;
    protected yscale: any;
    protected colors: any;
    protected gapSize: number;
    protected tooltip: any;
    // protected hoverEl: any;

    protected handleMouseOver = {
        line: (el, color) => {
            d3.select(this.parent)
                .selectAll(`.line${color.substring(1)}`)
                .style('stroke-width', consts.lineStrokeHover);
            d3.select(this.parent)
                .selectAll(`.point${color.substring(1)}`)
                .style('fill-opacity', consts.pointOpacityLineHover);
        },
        point: (el, color, value) => {
            d3.select(el).style('r', consts.pointRadiusHover);
            this.showTooltip(el, value);
        },
        bar: (el, color, value) => {
            // let width = parseFloat(el.getAttribute('width')),
            //     height = parseFloat(el.getAttribute('height')),
            //     x1 = parseFloat(el.getAttribute('x')),
            //     y1 = parseFloat(el.getAttribute('y')),
            //     x2 = x1 - width * 0.04,
            //     y2 = y1 - height * 0.02;
            // this.hoverEl.style('fill', color)
            //     .attr('width', width * 1.08)
            //     .attr('height', height * 1.04)
            //     .attr('x', x2).attr('y', y2);
            this.showTooltip(el, value);
        }
    };
    protected handleMouseOut = {
        line: (el, color) => {
            d3.select(this.parent)
                .selectAll(`.line${color.substring(1)}`)
                .style('stroke-width', consts.lineStroke);
            d3.select(this.parent)
                .selectAll(`.point${color.substring(1)}`)
                .style('fill-opacity', consts.pointOpacity);
        },
        point: (el, color) => {
            d3.select(el).style('r', consts.pointRadius);
            this.hideTooltip();
        },
        bar: (el, color) => {
            this.hideTooltip();
        }
    };

    constructor(divHeight: number, data: any, xlabels: any, colors: any) {
        let labelHeight = 40;
        if (xlabels[0].indexOf('-') > -1) {
            labelHeight = 60;
        }
        this.chartHeight = divHeight - labelHeight;
        this.data = data;
        this.xlabels = xlabels;
        this.yscale = this.getScale(0, this.chartHeight - labelHeight);
        this.colors = colors;
    }

    protected setData = (data) => {
        this.data = data;
    }

    public getScale = (min, max, data?) => {
        data = data ? data : this.data;
        let dmin = 0;
        let dmax = d3.max(data.map((d) => {
            if (Array.isArray(d)) {
                return d.reduce((a, b) => a + b, 0);
            } else {
                return d;
            }
        }));
        if (dmax > 0) {
            return d3.scaleLinear()
                .domain([dmin, dmax]).range([min, max]);
        } else {
            return d3.scaleLinear()
                .domain([0, 0]).range([0, 0]);
        }
    }

    plotLabels = (text, fx, fy) => {
        return this.chart.data(this.data)
            .enter().append('text')
            .text(text)
            .attr('x', fx).attr('y', fy)
            .attr('text-anchor', 'middle');
    }

    plotBars = (color, width, height, fx, fy) => {
        return this.chart.data(this.data)
            .enter().append('rect')
            .style('fill', color)
            .attr('width', width).attr('height', height)
            .attr('x', fx).attr('y', fy);
    }

    plotLines = (color, stroke, fx1, fy1, fx2, fy2) => {
        let slice = this.data.slice();
        slice.shift();
        return this.chart.data(slice)
            .enter().append('line')
            .attr('class', `line${color.substring(1)}`)
            .style('stroke', color)
            .style('stroke-width', stroke)
            .attr('x1', fx1).attr('y1', fy1)
            .attr('x2', fx2).attr('y2', fy2);
    }

    plotPoints = (color, fx, fy) => {
        return this.chart.data(this.data)
            .enter().append('circle')
            .attr('class', `point${color.substring(1)}`)
            .style('stroke', color)
            .style('fill', color)
            .style('fill-opacity', consts.pointOpacity)
            .attr('cx', fx).attr('cy', fy)
            .attr('r', 4);
    }

    plotCurves = (color, stroke, fx1, fy1, fx2, fy2) => {
        let clone = this.data.slice();
        clone.shift();
        let cx = this.gapSize / 2;
        // let self = this;
        return this.chart.data(clone)
            .enter().append('path')
            .attr('class', `line${color.substring(1)}`)
            .style('stroke', color)
            .style('stroke-width', stroke)
            .style('fill', 'none')
            .attr('d', (d, k) => {
                let x1 = fx1(d, k), y1 = fy1(d, k);
                let x2 = fx2(d, k), y2 = fy2(d, k);
                return `M ${x1 + ' ' + y1} 
                    C ${(x1 + cx) + ' ' + y1}
                    ${(x2 - cx) + ' ' + y2}
                    ${x2 + ' ' + y2}`;
            });
    }

    showTooltip = (el, value) => {
        console.log('tooltip', d3.select(el));
        this.tooltip.transition()
            .duration(200)
            .style('opacity', 0.8);
        let x = d3.select(el).attr('x');
        let y = d3.select(el).attr('y');
        console.log(x, y);
        this.tooltip.html(value)
            .attr('x', (parseFloat(x) + consts.barWidth + 5))
            .attr('y', (parseFloat(y) + 10));
    }

    hideTooltip = () => {
        this.tooltip.transition()
            .duration(500)
            .style('opacity', 0);
    }
}

class BarChart extends Chart {
    private type: any;
    private barWidth: number;
    private groupSize: number;

    constructor(
        chartDiv: any, divHeight: any, data: any, xlabels: any,
        colors: any, type?: any
    ) {
        super(divHeight, data, xlabels, colors);
        this.barWidth = consts.barWidth;
        if (xlabels[0].indexOf('-') > -1) {
            this.gapSize = this.barWidth;
        } else {
            this.gapSize = this.barWidth / 1.5;
        }
        this.groupSize = this.data[0].length;
        this.type = type;
        this.chart = chartDiv.select('svg')
            .attr('width', this.getChartWidth())
            .attr('height', divHeight)
            .style('background', 'white')
            .selectAll('rect');
        this.tooltip = chartDiv.select('svg')
            .append('text')
            .attr('class', 'tooltip')
            .style('opacity', 0);
        this.parent = this.chart._parents[0];
        this.plotChart();
    }

    plotChart = () => {
        let chartHeight = this.chartHeight;
        let yscale = this.yscale;

        if (this.type === 'stacked') {
            this.stackChart();
        } else if (this.type === 'grouped') {
            this.gapSize /= 2;
            this.groupChart();
        } else {
            this.plotBars(
                this.getScale('#74bcff', '#1890ff'),
                this.barWidth,
                (d) => d.reduce((a, b) => yscale(a) + yscale(b), 0),
                (d, k) => this.barx(k),
                (d) => chartHeight - yscale(d.reduce((a, b) => a + b, 0))
            );
        }

        if (this.type !== 'grouped') {
            this.plotLabels(
                (d) => d.reduce((a, b) => a + b, 0),
                (d, k) => this.barx(k) + this.barWidth / 2,
                (d) => chartHeight - yscale(d.reduce((a, b) => a + b, 0)) - 5
            );
            let rotateX = 0;
            let rotateY = 0;
            if (this.xlabels[0].indexOf('-') > -1) {
                rotateX = 10;
                rotateY = 40;
            }
            this.plotLabels(
                (d, k) => this.xlabels[k],
                (d, k) => this.barx(k),
                () => chartHeight + 30
            )
                .attr('font-size', 12)
                .attr('transform', (d, k) => {
                    return `rotate(-30, ${this.barx(k) + rotateX}, ${chartHeight + rotateY})`;
                });
            // d3.select(this.parent)
            //     .append('line')
            //     .style('stroke', 'grey')
            //     .style('stroke-width', 2)
            //     .attr('x1', (d, k) => this.barx(k) + this.barWidth / 2)
            //     .attr('y1', (d, k) => this.chartHeight)
            //     .attr('x2', (d, k) => this.barx(k) + this.barWidth / 2)
            //     .attr('y2', (d, k) => this.chartHeight + 5);
        }
        d3.select(this.parent)
            .append('line')
            .style('stroke', '#001629')
            .attr('x1', 0)
            .attr('y1', chartHeight)
            .attr('x2', this.getChartWidth())
            .attr('y2', chartHeight);
    }

    private getChartWidth = () => {
        if (this.type === 'grouped') {
            return (
                (this.data.length + 1) *
                (this.groupSize * this.barWidth + this.gapSize)
            );
        } else {
            return (this.data.length + 2) * (this.barWidth + this.gapSize);
        }
    }

    private barx = (i) => {
        if (this.type === 'grouped') {
            if (i % this.groupSize === 0) {
                return (i + 1) * (this.barWidth + this.gapSize);
            } else {
                return (
                    (i + 1) * (this.barWidth + this.gapSize)
                    - (i % this.groupSize) * this.gapSize
                );
            }
        } else {
            return (i + 1) * (this.barWidth + this.gapSize);
        }
    }

    private stackChart = () => {
        let yscale = this.yscale;
        let self = this;
        for (let i = 0; i < this.data[0].length; i++) {
            this.plotBars(
                this.colors[i],
                this.barWidth,
                (d) => this.yscale(d[i]),
                (d, k) => this.barx(k),
                (d) => {
                    let offset = 0;
                    if (i > 0) {
                        for (let k = i - 1; k >= 0; k--) {
                            offset += d[k];
                        }
                    }
                    return this.chartHeight - yscale(d[i]) - yscale(offset);
                }
            )
                .on('mouseover', function (d: any) {
                    self.handleMouseOver.bar(this, self.colors[i], d[i]);
                })
                .on('mouseout', function (d: any) {
                    self.handleMouseOut.bar(this, self.colors[i]);
                });
        }
    }

    private groupChart = () => {
        let chartHeight = this.chartHeight;
        this.setData([].concat(...this.data));
        let yscale = this.getScale(0, this.chartHeight - 40);
        this.plotBars(
            (d, k) => this.colors[k % this.groupSize],
            this.barWidth,
            (d, k) => yscale(d),
            (d, k) => this.barx(k),
            (d, k) => chartHeight - yscale(d)
        );
        this.plotLabels(
            (d) => d,
            (d, k) => this.barx(k) + this.barWidth / 2,
            (d) => chartHeight - yscale(d) - 5
        );
        let rotateX = 40;
        let rotateY = 30;
        if (this.xlabels[0].indexOf('-') > -1) {
            rotateX = 60;
            rotateY = 50;
        }
        this.plotLabels(
            (d, k) => {
                if (k % this.groupSize === 0) {
                    return this.xlabels[Math.floor(k / this.groupSize)];
                }
                return null;
            },
            (d, k) => this.barx(k) + (this.groupSize * this.barWidth) / 2,
            () => chartHeight + 20
        )
            .attr('font-size', 12)
            .attr('transform', (d, k) => {
                return `rotate(-30, ${this.barx(k) + rotateX}, ${this.chartHeight + rotateY})`;
            });
    }

}

class LineChart extends Chart {
    private strokeWidth: number;
    private type: any;
    private style: any;

    constructor(
        chartDiv: any, divHeight: any, data: any, xlabels: any,
        colors: any, type?: any, style?: any
    ) {
        super(divHeight, data, xlabels, colors);
        this.strokeWidth = consts.lineStroke;
        this.type = type;
        this.style = style;
        this.chart = chartDiv.select('svg')
            .attr('width', this.getChartWidth())
            .attr('height', divHeight)
            .style('background', 'white')
            .selectAll('line');
        this.plotChart();
        this.tooltip = chartDiv.select('svg')
            .append('text')
            .attr('class', 'tooltip')
            .style('opacity', 0);
        this.parent = this.chart._parents[0];
    }

    plotChart = () => {
        let chartHeight = this.chartHeight;
        let lineChart = this.plotLines;
        if (this.style === 'curved') {
            lineChart = this.plotCurves;
        }
        let self = this;
        if (this.type === 'multiline') {
            let flat = [].concat(...this.data);
            let yscale = this.getScale(0, this.chartHeight - 40, flat);

            for (let i = 0; i < this.data[0].length; i++) {
                lineChart(
                    this.colors[i],
                    this.strokeWidth,
                    (d, k) => (k + 1) * this.gapSize,
                    (d, k) => chartHeight - yscale(this.data[k][i]),
                    (d, k) => (k + 2) * this.gapSize,
                    (d, k) => chartHeight - yscale(d[i])
                )
                    .on('mouseover', function (d: any) {
                        self.handleMouseOver.line(this, self.colors[i]);
                    })
                    .on('mouseout', function (d: any) {
                        self.handleMouseOut.line(this, self.colors[i]);
                    });

                this.plotPoints(
                    this.colors[i],
                    (d, k) => (k + 1) * this.gapSize,
                    (d, k) => chartHeight - yscale(d[i])
                )
                    .on('mouseover', function (d: any) {
                        self.handleMouseOver.point(this, self.colors[0], d[i]);
                    })
                    .on('mouseout', function (d: any) {
                        self.handleMouseOut.point(this, self.colors[0]);
                    });
            }
        } else {
            let yscale = this.yscale;
            lineChart(
                this.colors[0],
                this.strokeWidth,
                (d, k) => (k + 1) * this.gapSize,
                (d, k) => {
                    return chartHeight -
                        yscale(this.data[k].reduce((a, b) => a + b, 0));
                },
                (d, k) => (k + 2) * this.gapSize,
                (d, k) => chartHeight - yscale(d.reduce((a, b) => a + b, 0))
            )
                .on('mouseover', function (d: any) {
                    self.handleMouseOver.line(this, self.colors[0]);
                })
                .on('mouseout', function (d: any) {
                    self.handleMouseOut.line(this, self.colors[0]);
                });

            this.plotPoints(
                this.colors[0],
                (d, k) => (k + 1) * this.gapSize,
                (d, k) => chartHeight - yscale(d)
            )
                .on('mouseover', function (d: any) {
                    self.handleMouseOver.point(this, self.colors[0], d);
                })
                .on('mouseout', function (d: any) {
                    self.handleMouseOut.point(this, self.colors[0]);
                });
        }

        this.plotLabels(
            (d, k) => this.xlabels[k],
            (d, k) => (k + 1) * this.gapSize,
            (d) => chartHeight + 20
        );
        this.plotLines(
            'grey',
            0.5,
            (d, k) => (k + 1) * this.gapSize,
            (d) => chartHeight,
            (d, k) => (k + 1) * this.gapSize,
            (d) => 5
        );
    }

    private getChartWidth = () => {
        this.gapSize = 60;
        return (this.data.length + 2) * this.gapSize;
    }
}

export { BarChart, LineChart };


// WEBPACK FOOTER //
// ./src/components/chart/Chart.ts